export default "__VITE_ASSET__959db7d0__"